import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";
import { useRccTypography } from "./typography";
import { rccColors } from "./colors";
import { fetchCompanyPreferredDataPeriod } from "./rccUtils";

const useStyles = makeStyles((theme) => ({
  navBar: {
    display: "flex",
    padding: "8px",
    alignItems: "flex-start",
    gap: "10px",
    alignSelf: "stretch",
    borderRadius: "8px",
    backgroundColor: rccColors.neutral[50],
  },
  navBarContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flex: "1 0 0",
  },
  dashboardLabelContainer: {
    display: "flex",
    padding: "8px 12px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "4px",
    background: "#FFF",
  },
  dateContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
  },
  calendarIcon: {
    color: rccColors.blue[800],
    width: "14px",
    height: "16px",
    aspectRatio: "7/8",
    fontSize: "16px",
  },
}));

function RccNavigationBar({ dashboardLabel = "Executive Dashboard" }) {
  const classes = useStyles();
  const typography = useRccTypography();
  const dispatch = useDispatch();

  // 1. Get data from Redux instead of local state
  const { companyPreferredData, updatingCompanyPreferredData } = useSelector(
    (state) => state.app,
  );

  useEffect(() => {
    // 2. Only fetch if data is missing and not currently fetching
    if (!companyPreferredData && !updatingCompanyPreferredData) {
      dispatch({ type: "get_company_preferred_data_request" });

      fetchCompanyPreferredDataPeriod()
        .then((info) => {
          dispatch({
            type: "get_company_preferred_data_success",
            payload: info,
          });
        })
        .catch((error) => {
          console.error("Failed to fetch company preferred data", error);
          dispatch({
            type: "get_company_preferred_data_failure",
            error,
          });
        });
    }
  }, [companyPreferredData, updatingCompanyPreferredData, dispatch]);

  const periodInfo = companyPreferredData || {
    period: null,
    currentPeriod: "",
  };
  const isPeriodLoading = !companyPreferredData;
  const currentPeriod = periodInfo.currentPeriod || "";
  const dateText =
    periodInfo.period === "monthly" && currentPeriod
      ? `${currentPeriod} MTD`
      : periodInfo.period === "quarterly" && currentPeriod
        ? `${currentPeriod} QTD`
        : "";

  return (
    <Box className={classes.navBar}>
      <Box className={classes.navBarContainer}>
        <Box className={classes.dashboardLabelContainer}>
          <Typography
            className={typography.textMediumSemibold}
            style={{ color: rccColors.blue[700] }}
          >
            {dashboardLabel}
          </Typography>
        </Box>
        {isPeriodLoading ? (
          <Box className={classes.dateContainer}>
            <Skeleton variant="circle" width={16} height={16} />
            <Skeleton variant="text" width={120} height={20} />
          </Box>
        ) : dateText ? (
          <Box className={classes.dateContainer}>
            <i className={`material-icons ${classes.calendarIcon}`}>
              calendar_month
            </i>
            <Typography
              className={typography.textMediumMedium}
              style={{ color: rccColors.neutral[500] }}
            >
              {dateText}
            </Typography>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}

export default RccNavigationBar;
